import DataGrid2 from '../../..';
import { IChangeSetArgs } from '../../../entities';

export async function rowChangeAction(this: DataGrid2, args: IChangeSetArgs | IChangeSetArgs[]) {
	const changeSet = Array.isArray(args) ? args : [args];
	const store = this.__bcDataGridRef.current.instance().getDataSource().store();

	for (const change of changeSet) {
		switch (change.type) {
			case 'insert': {
				await store.insert(change.data);
				break;
			}
			case 'update': {
				await store.update(change.key, change.data);
				break;
			}
			case 'remove': {
				await store.remove(change.key);
				break;
			}
		}
	}

	await this.__bcDataGridRef.current.instance().refresh();
}
